module.exports = __webpack_public_path__ + "static/media/1_en.a4da20e8.png";